import { render, staticRenderFns } from "./OnneCarrousel.vue?vue&type=template&id=611a1625&scoped=true&"
import script from "./OnneCarrousel.vue?vue&type=script&lang=ts&"
export * from "./OnneCarrousel.vue?vue&type=script&lang=ts&"
import style0 from "./OnneCarrousel.vue?vue&type=style&index=0&id=611a1625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a1625",
  null
  
)

export default component.exports